<script setup>

import { Bar } from 'vue-chartjs'
import { reactive} from "vue";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import {onMounted} from "vue";
import Duration from '@common/Duration';
import {DateTime} from "luxon";


const props = defineProps({
  chartId: {
    type: String,
    default: 'bar-chart'
  },
  width: {
    type: Number,
    default: 400
  },
  height: {
    type: Number,
    default: 400
  },
  cssClasses: {
    default: '',
    type: String
  },
  styles: {
    type: Object,
    default: () => {}
  },
  plugins: {
    type: Array ,
    default: () => []
  }
})

const chartData = reactive ({
  labels: [

  ],
  datasets: [
    {
      backgroundColor: 'rgb(60,173,144)',
      borderColor: 'rgb(60,173,144)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgb(194,149,209)',
      hoverBorderColor: 'rgb(221,99,255)',
      data: []
    }
  ],

})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins : {
    legend : {
      display :false
    },
  }

}

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const fetchDataForDuration = (duration) => {
  axios
    .get(
      route('api.graphs.fetch.updates',
        {duration : duration ,}
      )
    )
    .then((response) => {
      chartData.labels = response.data.map((item) => item['dates'].split('-').reverse().join('/'));
      chartData.datasets[0].data = response.data.map((item) => item['count']);
    })

    .catch((error) => {
      console.error(error)
    })
}

onMounted(() => {

})

</script>

<template>
  <div class="space-y-4">
    <div class="text-xl">Product aanpassingen</div>
    <p class = "text-sm">Aantal producten per dag waarvan de lokale prijs is bijgewerkt. </p>
    <Duration @update-selected="fetchDataForDuration" />
    <div>
      <Bar
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
  </div>
</template>



<style scoped>

</style>
